__turbopack_context__.v({
  "viewerDownloadButton": "_JD_kq_viewerDownloadButton",
  "viewerDownloadWrapper": "_JD_kq_viewerDownloadWrapper",
});
